/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_RemovedInputs */

const en_us2_profile_editors_pain_removed = /** @type {(inputs: Profile_Editors_Pain_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No more pain: exercises come back gradually`)
};

const pt_br2_profile_editors_pain_removed = /** @type {(inputs: Profile_Editors_Pain_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não dói mais: os exercícios voltam aos poucos`)
};

const es_419_profile_editors_pain_removed = /** @type {(inputs: Profile_Editors_Pain_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin dolor: los ejercicios vuelven de a poco`)
};

const pt_pt2_profile_editors_pain_removed = /** @type {(inputs: Profile_Editors_Pain_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já não dói: os exercícios voltam aos poucos`)
};

const fr_fr2_profile_editors_pain_removed = /** @type {(inputs: Profile_Editors_Pain_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de douleur : les exercices reviennent progressivement`)
};

const de_de2_profile_editors_pain_removed = /** @type {(inputs: Profile_Editors_Pain_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Schmerz mehr: Die Übungen kommen schrittweise zurück`)
};

const it_it2_profile_editors_pain_removed = /** @type {(inputs: Profile_Editors_Pain_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niente più dolore: gli esercizi tornano gradualmente`)
};

/**
* | output |
* | --- |
* | "No more pain: exercises come back gradually" |
*
* @param {Profile_Editors_Pain_RemovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_removed = /** @type {((inputs?: Profile_Editors_Pain_RemovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_RemovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_removed(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_removed(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_removed(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_removed(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_removed(inputs)
	return en_us2_profile_editors_pain_removed(inputs)
});
export { profile_editors_pain_removed as "profile-editors.pain_removed" }